<template>
  <CustomTextField
    v-model="formatedNumber"
    :label="label"
    :rules="rules"
    :focus="focus"
    :disabled="disabled"
    :error-messages="errorMessages"
    type="number"
    :step="step"
    :hide-details="hideDetails"
    :required="required"
    :readonly="readonly"
    :validate-on-blur="validateOnBlur"
    :outlined="outlined"
    @change="changeNumber"
    @focus="handleFocus"
    @blur="handleBlur"
    @input="changeNumber"
  />
</template>

<script>
import _ from "lodash";

export default {
  props: [
    "value",
    "scale",
    "required",
    "label",
    "rules",
    "disabled",
    "hideDetails",
    "readonly",
    "validateOnBlur",
    "errorMessages",
    "outlined",
    "focus",
  ],
  data: () => ({
    number: 0,
    formatedNumber: "",
  }),
  computed: {
    step() {
      if (this.scale > 0) {
        return _.floor(Math.pow(0.1, this.scale), this.scale);
      }
      if (this.scale === 0) {
        return 1;
      }
    },
  },
  watch: {
    value: {
      handler(val) {
        if (_.isFinite(val)) {
          this.number = val;
          this.formatedNumber = val.toFixed(this.scale);
        }
      },
      immediate: true,
    },
    formatedNumber(val) {
      if (!val) {
        this.number = +val;
      }
    },
  },
  methods: {
    changeNumber() {
      const pattern = /^-?[0-9]*.{1}[0-9]*$/;

      if (!this.formatedNumber) {
        return this.$emit("input", 0);
      }

      if (pattern.test(this.formatedNumber)) {
        this.number = _.floor(+this.formatedNumber, this.scale);
        this.formatedNumber = this.number.toFixed(this.scale);
        this.$emit("input", this.number);
      }
    },
    handleFocus() {
      if (!this.number) {
        this.formatedNumber = "";
      }
    },
    handleBlur() {
      if (!this.formatedNumber) {
        this.formatedNumber = this.number.toFixed(this.scale);
      }
    },
  },
};
</script>

<style>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
